import { Contact } from 'src/types/types.ts';

export const CONTACTS: Contact[] = [
  {
    name: 'Patrick Neumann',
    role: 'Senior Manager',
    email: 'Patrick.Neumann@zeb.de',
    image: '/contacts/Patrick%20Neumann.jpg'
  },
  {
    name: 'Hans Christian Panning',
    role: 'Manager',
    email: 'Hans-Christian.Panning@zeb.at',
    image: '/contacts/Hans%20Christian%20Panning.jpg'
  },
  {
    name: 'Celina Hain',
    role: 'Managerin',
    email: 'Celina.Hain@zeb.de',
    image: '/contacts/Celina%20Hain.jpg'
  },
  {
    name: 'Laisa Helmers',
    role: 'Consultant',
    email: 'Laisa.Helmers@zeb.de',
    image: '/contacts/Laisa%20Helmers.jpg'
  },
  {
    name: 'Rasheeda Duroshola',
    role: 'Consultant',
    email: 'Rasheeda.Duroshola@zeb.de',
    image: '/contacts/Rasheeda%20Duroshola.jpg'
  }
];
